module.exports = __webpack_public_path__ + "img/34_26.a2f6bc4c.png";